/* JS dung chung cho cac trang MCU.
 * Trich nguyen van bang mcu-build/extract-js.mjs — dung sua tay o day,
 * sua o file nguon roi chay lai script.
 * Gom: block chinh cua homepage.html + rieng phan tab .guide-tab cua contact.html.
 * Da bo: code upload file + submit gia cua careers/contact (nay dung {% form %} that).
 */
(function () {
const body = document.body;
  const menuToggle = document.querySelector('.menu-toggle');
  const mainNav = document.querySelector('.main-nav');
  const siteHeader = document.querySelector('.site-header');

  const closeMenu = () => {
    body.classList.remove('menu-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.setAttribute('aria-label', 'Open menu');
  };

  const updateMobileNavPosition = () => {
    if (!siteHeader) return;
    document.documentElement.style.setProperty(
      '--mobile-nav-top',
      `${Math.ceil(siteHeader.getBoundingClientRect().bottom)}px`
    );
  };

  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = body.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });

    mainNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && body.classList.contains('menu-open')) {
        closeMenu();
        menuToggle.focus();
      }
    });

    window.addEventListener('resize', () => {
      updateMobileNavPosition();
      if (window.innerWidth > 860) closeMenu();
    });

    updateMobileNavPosition();
  }

  document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const wasActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(other => {
        other.classList.remove('active');
        other.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!wasActive) {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: .08 })
    : null;

  document.querySelectorAll('.reveal').forEach(el => {
    if (observer) observer.observe(el);
    else el.classList.add('visible');
  });

  const year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

// ── Tab "Quick Support Guides" (trang contact) ──
const guideTabs = [...document.querySelectorAll('.guide-tab')];
  guideTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      guideTabs.forEach(other => {
        other.classList.remove('active');
        other.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.guide-panel').forEach(panel => panel.classList.remove('active'));
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      document.getElementById(tab.dataset.panel).classList.add('active');
    });
  });
})();
/* =========================================================
   MCU BLOG TABLE OF CONTENTS
   Auto H2 + H3 / Collapsible / Anchor Links
========================================================= */

(function () {
  'use strict';

  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function initBlogTOC() {

    /* Elessi article content */
    const article = document.querySelector('.post-content article');

    if (!article) return;

    /* Tránh tạo TOC hai lần */
    if (article.querySelector('.mcu-blog-toc')) return;

    const headings = Array.from(
      article.querySelectorAll('h2, h3')
    );

    const h2s = headings.filter(function (heading) {
      return heading.tagName === 'H2';
    });

    if (!h2s.length) return;


    /* =====================================================
       CREATE UNIQUE ANCHOR IDS
    ===================================================== */

    const usedIds = {};

    headings.forEach(function (heading, index) {

      let baseId = slugify(
        heading.id || heading.textContent
      );

      if (!baseId) {
        baseId = 'section-' + (index + 1);
      }

      let finalId = baseId;

      if (usedIds[baseId]) {
        usedIds[baseId]++;
        finalId = baseId + '-' + usedIds[baseId];
      } else {
        usedIds[baseId] = 1;
      }

      heading.id = finalId;
    });


    /* =====================================================
       CREATE TOC
    ===================================================== */

    const toc = document.createElement('details');

    toc.className = 'mcu-blog-toc';


    /* -------------------------
       HEADER
    ------------------------- */

    const summary = document.createElement('summary');

    summary.className = 'mcu-blog-toc__header';

    summary.innerHTML = `
      <span class="mcu-blog-toc__title">
        Table of Contents
      </span>

      <span class="mcu-blog-toc__control">

        <span class="mcu-blog-toc__show">
          Show
        </span>

        <span class="mcu-blog-toc__hide">
          Hide
        </span>

        <span
          class="mcu-blog-toc__arrow"
          aria-hidden="true"
        ></span>

      </span>
    `;

    toc.appendChild(summary);


    /* -------------------------
       CONTENT
    ------------------------- */

    const content = document.createElement('div');

    content.className = 'mcu-blog-toc__content';


    const mainList = document.createElement('ol');

    mainList.className = 'mcu-blog-toc__list';


    content.appendChild(mainList);

    toc.appendChild(content);


    /* =====================================================
       BUILD H2 / H3 HIERARCHY
    ===================================================== */

    let currentH2Item = null;


    headings.forEach(function (heading) {

      const text = heading.textContent.trim();

      if (!text) return;


      const link = document.createElement('a');

      link.href = '#' + heading.id;

      link.textContent = text;


      /* -------------------------
         H2
      ------------------------- */

      if (heading.tagName === 'H2') {

        const item = document.createElement('li');

        item.className = 'mcu-blog-toc__item';

        item.appendChild(link);

        mainList.appendChild(item);

        currentH2Item = item;

        return;
      }


      /* -------------------------
         H3
      ------------------------- */

      if (
        heading.tagName === 'H3' &&
        currentH2Item
      ) {

        let subList = currentH2Item.querySelector(
          ':scope > .mcu-blog-toc__sublist'
        );

        if (!subList) {

          subList = document.createElement('ol');

          subList.className = 'mcu-blog-toc__sublist';

          currentH2Item.appendChild(subList);
        }


        const subItem = document.createElement('li');

        subItem.className = 'mcu-blog-toc__subitem';

        subItem.appendChild(link);

        subList.appendChild(subItem);
      }

    });


    /* =====================================================
       INSERT BEFORE FIRST H2
    ===================================================== */

    const firstH2 = h2s[0];

    firstH2.parentNode.insertBefore(
      toc,
      firstH2
    );

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initBlogTOC
    );

  } else {

    initBlogTOC();
  }

})();

// ── Blog carousel (Dot 3) — cuon ngang bang nut prev/next, khong dung thu vien ──
(function () {
  var tracks = document.querySelectorAll('[data-mcu-blog-track]');
  if (!tracks.length) return;
  tracks.forEach(function (track) {
    var wrap = track.closest('[data-mcu-blog-carousel]');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-mcu-blog-prev]');
    var next = wrap.querySelector('[data-mcu-blog-next]');
    function step() {
      var card = track.querySelector('.mcu-blog-card');
      return card ? card.getBoundingClientRect().width + 24 : track.clientWidth;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();